<template>
	<v-input class="hiddenValidator" :rules="rules" v-bind="$attrs" v-on="$listeners"></v-input>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class HiddenValidator extends Vue {
	@Prop() rules: any[];
}
</script>

<style lang="scss">
	.hiddenValidator {
		margin-top: -16px;

		&.error--text {
			margin-top: 16px;
		}
	}
</style>